const flows = ['activate', 'unblock', 'reset', 'register', 'verify'];

const verifyFlow = (input: any): string =>
  flows.includes(input) ? input : 'default';

const requireExplicitFailure = (success: boolean): string =>
  success === false ? 'failure' : 'success';

const mapMessage = (message = ''): string => {
  const map: Record<string, string> = {
    'This URL can be used only once': 'reused_link',
    'Access expired.': 'access_expired',
    'The operation cannot be completed. Please try again.': 'generic_error',
  };
  const mapped: any = map[message];
  if (!mapped) {
    return '';
  }
  return `.${mapped}`;
};

const loginMessage = (
  flow: string,
  success = true,
  message?: string,
): string => {
  const mappedFlow = verifyFlow(flow);
  const mappedSuccess = requireExplicitFailure(success);
  const mappedCode = success ? '' : mapMessage(message);
  return `${mappedFlow}.${mappedSuccess}${mappedCode}`;
};

export default loginMessage;
